export const QUOTA_EXCEEDED_PATTERN =
  /spoonacular\s+402|\b402\b|points?\s+limit|daily\s+(?:points?\s+)?limit|quota|limit has been reached|upgrade your plan/i;

function getErrorText(payload) {
  if (!payload || typeof payload !== "object") return "";
  if (typeof payload.error === "string") return payload.error;
  if (typeof payload.message === "string") return payload.message;
  try {
    return JSON.stringify(payload);
  } catch {
    return "";
  }
}

export function isQuotaExceededPayload(payload) {
  if (payload?.key === "quotaExceeded") return true;
  return QUOTA_EXCEEDED_PATTERN.test(getErrorText(payload));
}

export function externalFoodErrorKey(status, payload) {
  if (status === 503) return "unavailable";
  if (
    isQuotaExceededPayload(payload) ||
    status === 402 ||
    status === 429 ||
    status === 502
  ) {
    return "quotaExceeded";
  }
  return "generic";
}

export function upstreamStatusFromError(error) {
  const status = Number(error?.status ?? error?.code);
  return Number.isFinite(status) ? status : null;
}

export function externalFoodFailBody(error, fallback) {
  const message = String(error?.message || fallback || "");
  const upstreamStatus = upstreamStatusFromError(error);

  if (
    isQuotaExceededPayload({ error: message }) ||
    upstreamStatus === 402 ||
    upstreamStatus === 429
  ) {
    return {
      status: 502,
      body: { key: "quotaExceeded", error: message },
    };
  }

  return {
    status: 502,
    body: { error: message },
  };
}
